import React, { useState, useEffect } from 'react';
import { Modal } from '@material-ui/core';
import Button from 'components/Button';
import TextField from 'components/TextField';
import { Container, WrapperInput, WrapperButtons } from './styles';

export default function ModalDefinirValor({ open, onClose, onConfirm, frete }) {
  const [valor, setValor] = useState('');
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');

  useEffect(() => {
    if (open && frete) {
      setValor(frete.valor_frete ? String(frete.valor_frete) : '');
      setErro('');
    }
  }, [open, frete]);

  const handleConfirm = async () => {
    const valorNumerico = parseFloat(valor);
    
    if (!valor || isNaN(valorNumerico) || valorNumerico <= 0) {
      setErro('Informe um valor válido maior que zero');
      return;
    }

    setLoading(true);
    try {
      await onConfirm(valorNumerico);
      handleClose();
    } catch (error) {
      setErro(error.message || 'Erro ao definir valor');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setValor('');
    setErro('');
    setLoading(false);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Container>
        <h2 style={{ marginBottom: '20px' }}>Definir Valor do Frete</h2>

        {frete && (
          <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
            <div style={{ fontSize: '14px', marginBottom: '5px' }}>
              <strong>Frete:</strong> FRETE Nº {frete.numero || '-'}
            </div>
            <div style={{ fontSize: '12px', color: '#666' }}>
              {frete.collect_city && frete.delivery_city && (
                <span>{frete.collect_city}-{frete.collect_state} → {frete.delivery_city}-{frete.delivery_state}</span>
              )}
            </div>
          </div>
        )}

        <WrapperInput>
          <TextField
            label="Valor do Frete (R$)"
            name="valor"
            type="number"
            value={valor}
            onChange={(e) => {
              setValor(e.target.value);
              setErro('');
            }}
            fullWidth
            color="secondary"
            placeholder="0.00"
            InputLabelProps={{ shrink: true }}
            inputProps={{
              step: "0.01",
              min: "0"
            }}
          />
        </WrapperInput>

        {erro && (
          <div style={{ color: '#f44336', marginBottom: '10px', fontSize: '14px' }}>
            {erro}
          </div>
        )}

        <WrapperButtons>
          <Button
            label="Cancelar"
            type="button"
            onClick={handleClose}
            disabled={loading}
            style={{ backgroundColor: '#999' }}
          />
          <Button
            label={loading ? 'Salvando...' : 'Confirmar'}
            type="button"
            onClick={handleConfirm}
            disabled={loading}
          />
        </WrapperButtons>
      </Container>
    </Modal>
  );
}

